import React, { type RefObject } from "react"
import { twMerge } from "tailwind-merge"

import { formatFontFamily } from "../../utils/fontUtils"

type ReviewsInfiniteScrollFooterProps = {
  sentinelRef: RefObject<HTMLDivElement | null>
  isLoading: boolean
  textColor?: string
  paragraphFont?: string
}

/** Fixed-height footer so the loader does not shift layout when infinite scroll fetches. */
export function ReviewsInfiniteScrollFooter({
  sentinelRef,
  isLoading,
  textColor = "#000000",
  paragraphFont
}: ReviewsInfiniteScrollFooterProps): React.ReactElement {
  return (
    <div className="flex w-full flex-col items-center justify-center py-6" style={{ overflowAnchor: "none" }}>
      <div
        className={twMerge(
          "flex min-h-8 items-center gap-3 transition-opacity duration-300 ease-out",
          isLoading ? "opacity-100" : "pointer-events-none opacity-0"
        )}
        aria-hidden={!isLoading}
        aria-live="polite">
        <div className="size-6 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600" />
        <span
          className="text-sm font-medium"
          style={{
            color: textColor,
            fontFamily: formatFontFamily(paragraphFont)
          }}>
          Loading more reviews...
        </span>
      </div>
      <div ref={sentinelRef} className="h-px w-full shrink-0" aria-hidden="true" />
    </div>
  )
}
